import { render, staticRenderFns } from "./LeadlikeEdit.vue?vue&type=template&id=231434fa&"
import script from "./LeadlikeEdit.vue?vue&type=script&lang=js&"
export * from "./LeadlikeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports